import React, { FC } from 'react';
import { Pagination } from 'react-bootstrap';

interface Props {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  onChange: (val: number) => void;
}

const LIMIT_PAGE = 11;

const PaginationComponent: FC<Props> = ({ currentPage, pageSize, totalCount, onChange }: Props) => {
  const maxPage = Math.ceil(totalCount / pageSize);

  const renderPages = () => {
    const pages: React.ReactNode[] = [];
    let startIndex;
    let endIndex;

    if (maxPage <= LIMIT_PAGE) {
      startIndex = 1;
      endIndex = maxPage;
    } else if (currentPage >= 1 && currentPage <= Math.floor(LIMIT_PAGE / 2)) {
      startIndex = 1;
      endIndex = LIMIT_PAGE;
    } else if (currentPage >= maxPage - Math.floor(LIMIT_PAGE / 2) && currentPage <= maxPage) {
      startIndex = maxPage - LIMIT_PAGE;
      endIndex = maxPage;
    } else {
      startIndex = currentPage - Math.floor(LIMIT_PAGE / 2);
      endIndex = currentPage + Math.floor(LIMIT_PAGE / 2);
    }

    if (startIndex > 1) {
      pages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let i = startIndex; i <= endIndex; i++) {
      pages.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => onClickPage(i)}>
          {i}
        </Pagination.Item>,
      );
    }

    if (endIndex < maxPage) {
      pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    return pages;
  };
  const onClickPage = (num: number) => {
    if (num > 0 && num <= maxPage) {
      onChange(num);
    }
  };
  return (
    <Pagination>
      <Pagination.First onClick={() => onClickPage(1)} />
      <Pagination.Prev onClick={() => onClickPage(currentPage - 1)} />
      {renderPages()}
      <Pagination.Next onClick={() => onClickPage(currentPage + 1)} />
      <Pagination.Last onClick={() => onClickPage(maxPage)} />
    </Pagination>
  );
};

export default PaginationComponent;
